import { FN } from '../services/functionalities.constants';

export interface MenuItem {
  label: string;
  route: string;
  icon: string;
  /** Visible when the user has ANY of these codes (empty = everyone). Codes live in services/functionalities.constants.ts. */
  fncodes: string[];
}

export interface MenuGroup {
  label: string;
  items: MenuItem[];
}

/** Sidebar navigation. Add items here as new portal screens are built (keep in sync with pages/pages.routes.ts). */
export const MENU_GROUPS: MenuGroup[] = [
  {
    label: 'Main',
    items: [{ label: 'Home', route: '/dashboard', icon: 'fa-house', fncodes: [] }],
  },
  {
    label: 'Administration',
    items: [{ label: 'Users', route: '/users', icon: 'fa-users', fncodes: [FN.USERS_MANAGE] }],
  },
];
